import Image from '@/assets/images/login-img-example from figma.png';
import Logo from "@/assets/images/logo/logo-yeda-phone.svg";
import {Input} from "@/components/ui/input.tsx";
import {LoadingButton} from "@/components/ui/button.tsx";
import {Label} from "@/components/ui/label.tsx";
// import {Checkbox} from "@/components/ui/checkbox.tsx";
import {Wrapper} from "./components/wrapper.tsx";
import {Link} from "react-router";
import {ChangeEvent, FormEvent, useState} from "react";
import {Head} from "@/layout/Head.tsx";
import {useGuestPage} from "@/hooks/useGuestPage.ts";
import {Alert, AlertDescription, AlertTitle} from "@/components/ui/alert.tsx";

export default function LoginPage() {

    const [{username, password}, setData] = useState({username: '', password: ''});

    const [error, setError] = useState<string>('');

    const { login, isLoading } = useGuestPage();

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        const {name, value} = e.target;
        setData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    async function handleSubmit(e:  FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if([username, password].some(t => t.trim().length === 0)){
            return setError('אנא מלא את כל השדות');
        }

        await login({username, password}).catch(err => {
            setError(err.response.data.msg);
        });
    }

    return (
            <Wrapper>
                <Head title="התחברות"/>
                <div className="flex flex-col justify-center items-center w-full">
                    <div className="flex w-96 flex-col gap-8">
                        <div className="flex justify-center h-8 w-8 overflow-hidden">
                                <img
                                    alt="ידע פון"
                                    src={Logo}
                                    className="object-cover object-right"
                                />
                        </div>
                        <div>
                            <div className="text-2xl font-medium">התחברות לחשבון</div>
                        </div>
                        <Alert variant="danger" className="bg-red-50 border-red-200">
                            <AlertTitle className="text-lg">
                                שים לב!
                            </AlertTitle>
                            <AlertDescription className="!text-red-700">
                                גם לבעלי חשבון בממשק הישן חובה לבצע רישום מחדש על מנת להשתמש בממשק החדש.
                                <Link className="text-sm border-b hover:opacity-80 border-dotted transition" to="/register">הירשם כאן</Link>
                            </AlertDescription>
                        </Alert>
                        <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                            <div>
                                <Label htmlFor="username">כתובת אימייל</Label>
                                <Input
                                    name="username"
                                    id="username"
                                    type="text"
                                    value={username}
                                    onChange={handleChange}
                                    className="w-full h-10 px-3 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:border-light-blue-500"
                                />
                            </div>
                            <div>
                                <Label htmlFor="password">סיסמא</Label>
                                <Input
                                    value={password}
                                    onChange={handleChange}
                                    name="password"
                                    id="password"
                                    type="password"
                                    className="w-full h-10 px-3 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:border-light-blue-500"
                                />
                            </div>
                            {/*<div className="flex justify-between">*/}
                            {/*    <div className="flex gap-2 items-center ">*/}
                            {/*        <Checkbox name="remmember" id="remmember"/>*/}
                            {/*        <Label htmlFor="remmember">זכרו אותי</Label>*/}
                            {/*    </div>*/}
                            {/*    <div className="text-sm  text-light-blue-600 cursor-pointer">שכחת סיסמה?</div>*/}
                            {/*</div>*/}
                            <div className="flex justify-center items-center">
                                <LoadingButton
                                    isLoading={isLoading}
                                    size="lg"
                                    className="w-full"
                                >
                                    כניסה
                                </LoadingButton>
                            </div>
                            <div>
                                {error && <div className="text-red-500 text-sm">{error}</div>}
                            </div>
                        </form>
                        <div className="flex gap-1 items-center">
                            <div className="text-sm text-gray-500">חדש כאן?</div>
                            <Link className="text-sm text-gray-400 hover:text-gray-500 border-b border-dotted transition" to="/register">הירשם</Link>
                        </div>
                    </div>
                </div>
                <div className="w-full h-full bg-cover bg-center bg-no-repeat" style={
                    {backgroundImage: `url(${Image})`}
                }>

                </div>
      </Wrapper>
    )
}